"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _reactRedux = require("react-redux");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Button = _interopRequireDefault(require("../../../../../ui/Button"));
var _actions = require("../../../../store/actions");
var _CreateCollectionModal = require("../../../CreateCollectionModal");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var CreateCollectionButton = function CreateCollectionButton(_ref) {
  var countryID = _ref.countryID,
    hotelID = _ref.hotelID;
  var _useTranslation = (0, _reactI18next.useTranslation)('ADD_HOTEL_TO_COLLECTIONS_MODAL'),
    t = _useTranslation.t;
  var dispatch = (0, _reactRedux.useDispatch)();
  var openCreateCollectionModal = function openCreateCollectionModal() {
    return dispatch((0, _CreateCollectionModal.showCreateCollectionModal)(undefined, {
      countryID: countryID,
      onSuccess: function onSuccess(_ref2) {
        var collectionID = _ref2.id;
        return dispatch((0, _actions.addHotelToCollection)(hotelID, collectionID));
      }
    }));
  };
  return /*#__PURE__*/_react.default.createElement(_Button.default, {
    type: "button",
    onClick: openCreateCollectionModal
  }, t('CREATE_NEW_COLLECTION_BUTTON'));
};
CreateCollectionButton.propTypes = {
  hotelID: _propTypes.default.number.isRequired,
  countryID: _propTypes.default.number
};
var _default = exports.default = (0, _react.memo)(CreateCollectionButton);